// --- src/components/ProtectedRoute.jsx ---
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" />;

  if (requiredRole && user.role !== requiredRole) {
    // Redirect each role to their own dashboard
    if (user.role === 'admin')         return <Navigate to="/admin/dashboard" />;
    if (user.role === 'company_admin') return <Navigate to="/company-admin/dashboard" />;
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
